import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import MobileTabBar from "./components/MobileTabBar";

import Landing from "./pages/Landing";
import EventDetail from "./pages/EventDetail";
import Login from "./pages/Login";
import OrganizerSetup from "./pages/OrganizerSetup";
import OrganizerDashboard from "./pages/OrganizerDashboard";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminEventEditor from "./pages/admin/AdminEventEditor";
import AdminEventAnalytics from "./pages/admin/AdminEventAnalytics";
import AdminOrganizers from "./pages/admin/AdminOrganizers";
import AdminSystem from "./pages/admin/AdminSystem";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/organizer/setup/:token" element={<OrganizerSetup />} />

          <Route
            path="/organizer"
            element={
              <ProtectedRoute role="organizer">
                <OrganizerDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="super_admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<AdminOverview />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="events/:id" element={<AdminEventEditor />} />
            <Route path="events/:id/analytics" element={<AdminEventAnalytics />} />
            <Route path="organizers" element={<AdminOrganizers />} />
            <Route path="system" element={<AdminSystem />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <MobileTabBar />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
